export default {
  "config": {
    "trial": "tones-3",
    "id": "ae-duration",
    "type": "table",
    "title": "Duration of Common Early-Onset TEAEs<sup>19</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<sup>a</sup>Combined doses includes solriamfetol <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> <no-break>150 mg,</no-break> and <no-break>300 mg.</no-break>",
      "<sup>b</sup>Combined doses without <no-break>300 mg</no-break> includes solriamfetol <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> and <no-break>150 mg.</no-break>"
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "tones-3",
    "id": "ae-duration",
    "data-type": "table",
    "title": "Duration of Common Early-Onset TEAEs<sup>19</sup>",
    "num-header-rows": 2,
    "num-columns": 7,
    "col-classes": [
      "col-1",
      "pbo",
      "pbo",
      "combined",
      "combined",
      "combined-300",
      "combined-300"
    ],
    "row-mergeoption": [
      1,
      2
    ],
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-a",
      "footnote-b"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-a": "<sup>a</sup>Combined doses includes solriamfetol <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> <no-break>150 mg,</no-break> and <no-break>300 mg.</no-break>",
    "footnote-b": "<sup>b</sup>Combined doses without <no-break>300 mg</no-break> includes solriamfetol <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> and <no-break>150 mg.</no-break>",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Placebo<br>(n = 119)</b></center>",
          "cols": 2,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<center><b>Combined solriamfetol<br>(all doses<sup>a</sup>)<br>(n = 355)</b></center>",
          "cols": 2,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "<center><b>Combined solriamfetol<br>(without 300 mg<sup>b</sup>)<br>(n = 237)</b></center>",
          "cols": 2,
          "class": "combined-300"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>TEAE</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>With TEAE, n</b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>Duration<br>median (min, max), d</b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>With TEAE, n</b>",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "<b>Duration<br>median (min, max), d</b>",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "<b>With TEAE, n</b>",
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "<b>Duration<br>median (min, max), d</b>",
          "cols": 1,
          "class": "combined-300"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Headache",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 13,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1, 86)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 40,
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "5.5 (1, 112)",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": 20,
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "8 (1, 86)",
          "cols": 1,
          "class": "combined-300"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Nausea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (1, 83)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 33,
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "10 (1, 86)",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": 17,
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "8 (1, 86)",
          "cols": 1,
          "class": "combined-300"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Decreased appetite",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 1,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "68 (68, 68)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 28,
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "57 (5, 91)",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": 13,
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "18 (6, 83)",
          "cols": 1,
          "class": "combined-300"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "Anxiety",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "n/a",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 25,
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "26 (1, 94)",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": 9,
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "36 (1, 94)",
          "cols": 1,
          "class": "combined-300"
        }
      ],
      "row-6": [
        {
          "indent": 0,
          "content": "Insomnia",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "6 (2, 10)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 16,
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "8.5 (1, 49)",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": 4,
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "21 (1, 49)",
          "cols": 1,
          "class": "combined-300"
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "Feeling jittery",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "n/a",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 15,
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": "4 (1, 49)",
          "cols": 1,
          "class": "combined"
        },
        {
          "indent": 0,
          "content": 7,
          "cols": 1,
          "class": "combined-300"
        },
        {
          "indent": 0,
          "content": "4 (3, 49)",
          "cols": 1,
          "class": "combined-300"
        }
      ]
    }
  }
};